import { render } from "./user-guide.vue?vue&type=template&id=58afbb4a"
import script from "./user-guide.vue?vue&type=script&lang=js"
export * from "./user-guide.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__